<section class="py-14">
  @if (data.title; as title) {
    <div class="centered-with-padding pb-6">
      <app-title [title]="title" size="h2" />
    </div>
  }

  @if (data.videos; as videos) {
    @let total = videos.length;
    <div class="desk:centered-with-padding w-screen snap-x snap-mandatory overflow-x-auto scroll-smooth desk:w-screen">
      <div class="flex desk:justify-between">
        @for (video of videos; track video.url; let i = $index) {
          <div
            [class.pl-5]="i !== total - 1"
            [class.px-5]="i === total - 1"
            class="h-[480px] w-[334px] shrink-0 snap-start desk:p-0">
            <div class="size-full overflow-hidden rounded-[30px]">
              @if (videoGroupName(); as groupName) {
                <app-video
                  [autoplay]="$first"
                  [groupName]="groupName"
                  [isImagePriority]="!isImageInPreviousBlocks"
                  [loop]="true"
                  [muted]="true"
                  [posterPregenerationSize]="{ width: 334, height: 480, exact: 'desk' }"
                  [video]="video" />
              }
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (data.cta; as cta) {
    <div class="centered-with-padding flex justify-center pt-6">
      <app-button [label]="cta.label" [url]="cta.url" />
    </div>
  }
</section>
